<template>
  <kbd class="text-keyboard-key">{{ getKeyboardKeySymbol(props.keyboardKey) }}</kbd>
</template>

<script setup lang="ts">
import {
  EKeyboardKey,
} from '../../constants/keyboard.ts';
import {
  getKeyboardKeySymbol,
} from '../../utils/keyboard-key-symbol.ts';

const props = defineProps<{
  /** The keyboard key to display. */
  keyboardKey: EKeyboardKey,
}>();
</script>

<style scoped lang="scss">
.text-keyboard-key {
  display: inline-block;
  padding: 0.1em 0.4em;
  font-family: inherit;
  font-size: 0.8em;
  line-height: 1.4;
  color: inherit;
  background-color: color-mix(in srgb, currentcolor 15%, transparent);
  border: 1px solid color-mix(in srgb, currentcolor 35%, transparent);
  border-radius: 3px;
  white-space: nowrap;
}
</style>
